module.exports = __webpack_public_path__ + "img/orange3.26e08e67.jpg";